import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import BorrowAdvanceMG from '../../../widgets/migrateEfin/BorrowAdvanceMG'
import { GetMigrateBorrowAdvancePage } from '../../../redux/actions/migrateEfin'
import BorrowAdvanceMGEfin from '../../../widgets/migrateEfin/BorrowAdvanceMGEfin'

export default function BorrowAdvance() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await GetMigrateBorrowAdvancePage()
      if (response.model) {
        setSchema(response.model)
      } else {
        setError({})
      }
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />
        {schema.borrowAdvanceEfin && (
          <>
            <BorrowAdvanceMGEfin schema={schema.borrowAdvanceEfin} />
          </>
        )}
        {schema.borrowAdvance && (
          <>
            <BorrowAdvanceMG schema={schema.borrowAdvance} />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
